import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Disclaimer = () => {
  // Scroll to top when component mounts
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-6">
          <Button
            variant="ghost"
            asChild
            className="text-legal-blue hover:text-legal-navy">
            <Link to="/" className="flex items-center gap-2">
              <ArrowLeft size={16} />
              Volver al Inicio
            </Link>
          </Button>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-legal-navy">
          Aviso Legal
        </h1>
        <p className="text-sm text-gray-500 mb-6">
          Última actualización: 7 de abril de 2025
        </p>

        <div className="prose max-w-none prose-headings:text-legal-navy prose-a:text-legal-blue">
          <p className="mb-6">
            Por favor, lea este aviso legal cuidadosamente antes de usar los
            servicios de MiAsistenteLegalIA.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            No Constituye Asesoramiento Legal
          </h2>
          <p className="mb-6">
            La información proporcionada en este sitio web y a través de
            nuestros servicios es solo para fines informativos generales. No
            constituye asesoramiento legal y no debe ser tratada como tal. El
            contenido no pretende crear una relación abogado-cliente.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Limitación de Garantías
          </h2>
          <p className="mb-6">
            La información se proporciona "tal cual", sin garantías de ningún
            tipo, expresas o implícitas, incluyendo, pero no limitado a,
            garantías implícitas de comerciabilidad, idoneidad para un propósito
            particular y no infracción.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Precisión de la Información
          </h2>
          <p className="mb-6">
            Hacemos todo lo posible para mantener la información precisa y
            actualizada. Sin embargo, no garantizamos que toda la información
            sea precisa, completa o actual. La información puede contener
            errores técnicos o tipográficos.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Uso de la Inteligencia Artificial
          </h2>
          <p className="mb-6">
            Nuestros servicios utilizan tecnología de inteligencia artificial
            para proporcionar asistencia legal automatizada. Sin embargo:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">
              La IA no sustituye el juicio de un abogado calificado
            </li>
            <li className="mb-2">
              Las respuestas generadas son basadas en patrones y datos
              históricos
            </li>
            <li className="mb-2">
              Para casos complejos o situaciones críticas, siempre recomendamos
              consultar con un profesional legal
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Limitación de Responsabilidad
          </h2>
          <p className="mb-6">
            En ningún caso MiAsistenteLegalIA será responsable por daños
            directos, indirectos, incidentales, consecuentes, especiales o
            punitivos, incluyendo, sin limitación, pérdida de beneficios, datos,
            uso, buena voluntad u otras pérdidas intangibles, resultantes de:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">
              El uso o la imposibilidad de usar el servicio
            </li>
            <li className="mb-2">
              Cualquier decisión tomada basada en la información proporcionada
            </li>
            <li className="mb-2">
              Errores, omisiones o inexactitudes en el contenido
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Enlaces a Terceros
          </h2>
          <p className="mb-6">
            Nuestro sitio web puede contener enlaces a sitios de terceros. No
            tenemos control sobre el contenido, las políticas de privacidad o
            las prácticas de los sitios de terceros y no asumimos ninguna
            responsabilidad por ellos.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Cambios al Aviso Legal
          </h2>
          <p className="mb-6">
            Nos reservamos el derecho de modificar este aviso legal en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación en el sitio web.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Contáctenos</h2>
          <p className="mb-6">
            Si tiene alguna pregunta sobre este Aviso Legal, por favor
            contáctenos:
          </p>
          <p>
            <strong>Correo electrónico:</strong>{" "}
            notificaciones@miasistentelegalia.com
            <br />
            <strong>Dirección:</strong> Medellin,Colombia
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Disclaimer;
